import(/* webpackMode: "eager", webpackExports: ["Bonuses"] */ "/home/nexts/lm-master-front/src/flat-pages/bonuses/index.tsx");
